import React from 'react'
import PropTypes from 'prop-types'

import {
    CouponPack,
    CouponPackPrice,
    CouponPackSelect,
    CouponPackTitle,
    CouponPackFieldBtn,
    CouponPackBtn,
    Coupon,
    CouponPrice,
    CouponPackLayout,
} from './layout.js'
import { Flex, Button, Copy, Dropdown, useConfig, Currency } from '@elparking/components'
import SelectableText from 'commons/js/ui/SelectableText'
import { FormattedMessage, injectIntl } from 'react-intl'

import messages from './messages'

const CouponWrapper = ({children, ...restProps}) => {
    const country = useConfig('country')
    const flavor = useConfig('flavor')
    const excludedFlavors = useConfig('excludedFlavors')
    return (
        <Coupon
          {...restProps}
          country={country}
          flavor={flavor}
          excludedFlavors={excludedFlavors}
        >
            {children}
        </Coupon>
    )
}

CouponWrapper.propTypes = {
    children: PropTypes.node,
}

class CouponPackSelector extends React.Component {
    message (message) {
        return this.props.intl.formatMessage(message)
    }

    static propTypes = {
        couponPrice: PropTypes.number.isRequired,
        couponCurrency: PropTypes.string.isRequired,
        couponOptions: PropTypes.array.isRequired,
        goToShop: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
    }

    constructor (props) {
        super(props)

        this.state = {
            option: null,
            selected: false,
        }

        this.onClickSelect = this.onClickSelect.bind(this)
        this.selectOption = this.selectOption.bind(this)
        this.goToShop = this.goToShop.bind(this)
    }

    onClickSelect () {
        this.setState({
            selected: true,
        })
    }

    selectOption (option) {
        this.setState({option})
    }

    goToShop () {
        this.props.goToShop(
            this.state.option,
            this.props.couponPrice
        )
    }

    renderDropdownInlineOption (option) {
        return (option.value + ' ' + option.label)
    }

    renderSelect (options) {
        if (this.state.selected) {
            return (
                <Dropdown
                  placeholder={this.message(messages.selectCoupons)}
                  renderPlaceholder={() => this.message(messages.selectCoupons)}
                  renderSelected={this.renderDropdownInlineOption}
                  renderOptionNative={this.renderDropdownInlineOption}
                  renderOption={(option) => (
                      <Flex>
                          <Copy color='main' padding='0 8px 0' size='small' fontWeight='medium'>{option.value}</Copy>
                          <Copy color='main' padding='0' size='small' fontWeight='regular'>
                              {option.label}
                          </Copy>
                      </Flex>
                  )}
                  options={options}
                  onChange={this.selectOption}
                />
            )
        }

        return (
            <SelectableText>
                <FormattedMessage defaultMessage='Selecciona' />
            </SelectableText>)
    }

    renderGoToShopBtn () {
        if (this.state.option === null) {
            return null
        }

        return (
            <CouponPackBtn>
                <Button dataTest='add-to-shop-button' className='coupon-pack__btn' onClick={this.goToShop}>
                    <FormattedMessage defaultMessage='Añadir a la compra' />
                </Button>
            </CouponPackBtn>
        )
    }

    render () {
        const {couponPrice: amount, couponCurrency: currency, couponOptions} = this.props
        const qty = {amount, currency}
        return (
            <CouponPack className={this.state.selected ? 'selected' : ''}>
                <CouponPackLayout className={this.state.selected ? 'selected' : ''}>
                    <CouponPackTitle>
                        <FormattedMessage defaultMessage='Cupones' />
                    </CouponPackTitle>
                    <CouponPackPrice>
                        <Currency qty={qty} />
                    </CouponPackPrice>
                    <CouponWrapper>
                        <CouponPrice>
                            <Currency qty={qty} />
                        </CouponPrice>
                    </CouponWrapper>
                    <CouponPackSelect onClick={this.onClickSelect}>
                        {this.renderSelect(couponOptions)}
                    </CouponPackSelect>
                    <CouponPackFieldBtn>
                        {this.renderGoToShopBtn()}
                    </CouponPackFieldBtn>
                </CouponPackLayout>
            </CouponPack>
        )
    }
}
export default injectIntl(CouponPackSelector)
